import React from "react";
import { Box, Flex, Text, Image, Container } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box bg="#fff" py={6}>
      <Container maxW="container.xl">
        <Flex
          w="100%"
          height="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Image alt="Logo" src="/assets/images/logo-preta.png" />
          <Text fontSize="12px" color="#000" textAlign="right">
            Copyright 2022©
          </Text>
        </Flex>
        <Text mt={2} fontSize="13px" color="#000" textAlign="left">
          CERTIFICADO DE AUTORIZAÇÃO SECAP/ME N. 17377.001817/2022-43
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;
